function About() {
  return <p style={{ padding: "40px" }}>
    SMARKET is a handmade crafts marketplace designed to support local artisans by providing an easy-to-use online shopping platform. The project is developed using React.js and focuses on simplicity, usability, and modern web design. <br />
    SMARKET focuses on simplicity and ease of use, ensuring that users can browse products, view details, and explore different craft categories without any complexity. <br />
    SMARKET serves as a practical and user-centric e-commerce solution that highlights handmade crafts while promoting local talent through a modern, lightweight React-based web application.
  </p>;
  
}
export default About;
